// extracted by mini-css-extract-plugin
export default {"section":"Header_section__wJXyG","container":"Header_container__Afn+2"};